import React from 'react';
import uniqid from 'uniqid';
import { Link as RouterLink } from 'react-router-dom';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import { formatDate } from 'helpers/dates-formatter';

interface CardItem {
  name?: string;
  coverDescription?: string;
  route: string;
  date?: string;
  coverImage?: string;
}

interface CardsProps {
  items?: CardItem[];
  contentType?: string;
}

const Cards = ({ items = [], contentType }: CardsProps): React.JSX.Element => (
  <ResponsiveWrapper customClass="grid mobile:grid-cols-1 tablet:grid-cols-2 xs:grid-cols-3 lg:grid-cols-4 gap-6">
    {items.map(({ name, coverDescription, route, date, coverImage }) => (
      <RouterLink
        to={route}
        key={uniqid()}
        className="border border-navy-200 rounded w-full"
      >
        {coverImage ? (
          <img
            src={coverImage}
            alt={`${contentType} ${name}`}
            className="block w-full h-auto rounded-tl rounded-tr"
          />
        ) : (
          <div className="w-full aspect-[16/10] tablet:bg-bottom categories-bg rounded-tl rounded-tr"></div>
        )}

        <div className="p-5">
          <div className="flex justify-between items-center">
            <div className="bg-navy-50 px-2.5 py-1 rounded w-fit text-navy-800 text-sm ">
              {contentType}
            </div>
            {date && (
              <div className="text-navy-500 text-sm font-semibold">
                {formatDate(date, 'MMM D, YYYY') || date}
              </div>
            )}
          </div>

          <h3 className="text-neutral-900 text-xl font-semibold py-2">
            {name}
          </h3>
          <div className="text-neutral-900 text-base">{coverDescription}</div>
        </div>
      </RouterLink>
    ))}
  </ResponsiveWrapper>
);

export default Cards;
